<template>
	<Tab :class="{ open }" v-bind="$props" @toggle="toggle">
		<template v-slot:header>
			<TabHeader
				icon="plastic"
				label="Plastic bottles"
				:value="value"
				:open="open"
			/>
		</template>
		<template v-slot:content>
			<Corridor>
				<p class="tab__prompt">
					How many plastic bottles under 3L does your household go through each
					week?
				</p>
				<div class="tab__sliders">
					<Slider
						v-for="slider in sliders"
						:key="slider.label"
						v-bind="slider.data"
						v-model="slider.slider"
						@dragend="trackSlider(slider.data)"
					/>
				</div>
			</Corridor>
		</template>
	</Tab>
</template>

<script>
import tab from '@/mixins/tab'
import sliders from '@/mixins/sliders'
import sliderAnalytics from '@/mixins/sliderAnalytics'

const SLIDERS = [
	{ title: 'Water' },
	{ title: 'Soft drink' },
	{ title: 'Sports drinks' }
]

export default {
	name: 'TabPlastic',
	mixins: [tab, sliders(SLIDERS), sliderAnalytics('Plastic Bottles')]
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins';
@include tab($green-53);
</style>
